module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    class: {
      "sideBarStyle": true, "openSideBar": _vm.sidebarToggle
    },
    on: {
      "mouseleave": _vm.closeSideBar
    }
  }, [_c('div', {
    class: {
      "hide": !_vm.sidebarToggle
    }
  }, [_c('label', {
    staticClass: "headerForOffer"
  }, [_vm._v(_vm._s(this.sidebarHeader))]), _vm._v(" "), (_vm.type === 'offerList') ? _c('div', {
    staticClass: "width_full"
  }, [_c('searchable-dropdown', {
    attrs: {
      "id": 10,
      "list": _vm.offerNames,
      "defaultText": _vm.selectedOfferId,
      "selectedItem": _vm.cloneOfferName,
      "screenName": _vm.screenName
    },
    model: {
      value: (_vm.selectedOfferName),
      callback: function($$v) {
        _vm.selectedOfferName = $$v
      }
    }
  })], 1) : (_vm.type === 'pendingApprovals') ? _c('div', {
    staticClass: "margin-reset padding-reset grid-12"
  }, [(_vm.superUser) ? _c('div', {}, [_c('label', {
    staticClass: "ddHeaders"
  }, [_vm._v("MERCHANTS:")]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": "vendorId1",
      "list": _vm.merchants,
      "defaultText": _vm.defaultText,
      "selectedItem": _vm.selectedMerchantValue
    },
    model: {
      value: (_vm.selectedMerchant),
      callback: function($$v) {
        _vm.selectedMerchant = $$v
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ddHeaders"
  }, [_vm._v("MANUFACTURERS:")]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": "superuser1",
      "list": _vm.emails,
      "defaultText": _vm.defaultText,
      "selectedItem": _vm.selectedItem
    },
    model: {
      value: (_vm.selectedVendor),
      callback: function($$v) {
        _vm.selectedVendor = $$v
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ddHeaders"
  }, [_vm._v("OFFERS:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "id": 100,
      "list": _vm.offers,
      "defaultText": _vm.defaultOfferName,
      "selectedItem": (_vm.gettersAggInputDataName.offers) ? _vm.gettersAggInputDataName.offers.name : ""
    },
    model: {
      value: (_vm.selectedOfferId),
      callback: function($$v) {
        _vm.selectedOfferId = $$v
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ddPeriods"
  }, [_vm._v("PERIODS:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "id": 200,
      "list": _vm.periods,
      "defaultText": _vm.defaultPeriod,
      "selectedItem": (_vm.gettersAggInputDataName.period) ? _vm.gettersAggInputDataName.period.name : ""
    },
    model: {
      value: (_vm.selectedPeriod),
      callback: function($$v) {
        _vm.selectedPeriod = $$v
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ddCategory"
  }, [_vm._v("CATEGORIES:")]), _vm._v(" "), _c('label', {
    staticClass: "all-categories",
    on: {
      "click": _vm.removeFilter
    }
  }, [_vm._v("See All Categories")]), _vm._v(" "), _c('div', {
    staticClass: "category-body"
  }, [_c('label', {
    staticClass: "ddSubHeaders"
  }, [_vm._v("DEPARTMENTS:")]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": 1,
      "list": _vm.departments,
      "selectedItem": _vm.department ? _vm.department.name : null
    },
    model: {
      value: (_vm.selectedDepartment),
      callback: function($$v) {
        _vm.selectedDepartment = $$v
      }
    }
  }), _vm._v(" "), (_vm.department) ? _c('label', {
    staticClass: "ddSubHeaders"
  }, [_vm._v(" SUB-DEPARTMENTS:")]) : _vm._e(), _vm._v(" "), (_vm.department) ? _c('searchable-dropdown', {
    attrs: {
      "id": 2,
      "list": _vm.subDepartments,
      "selectedItem": _vm.subDepartment ? _vm.subDepartment.name : null
    },
    model: {
      value: (_vm.selectedSubDepartment),
      callback: function($$v) {
        _vm.selectedSubDepartment = $$v
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subDepartment && _vm.subDepartment !== null) ? _c('label', {
    staticClass: "ddSubHeaders"
  }, [_vm._v(" CLASSES:")]) : _vm._e(), _vm._v(" "), (_vm.subDepartment && _vm.subDepartment !== null) ? _c('searchable-dropdown', {
    attrs: {
      "reset": _vm.reset._class,
      "id": 3,
      "list": _vm._class,
      "selectedItem": _vm.textClass ? _vm.textClass.name : null
    },
    model: {
      value: (_vm.selectedClass),
      callback: function($$v) {
        _vm.selectedClass = $$v
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.textClass && _vm.textClass !== null) ? _c('label', {
    staticClass: "ddSubHeaders"
  }, [_vm._v("SUB-CLASSES:")]) : _vm._e(), _vm._v(" "), (_vm.textClass && _vm.textClass !== null) ? _c('searchable-dropdown', {
    attrs: {
      "reset": _vm.reset.subClass,
      "id": 4,
      "list": _vm.subClasses,
      "selectedItem": _vm.subClass ? _vm.subClass.name : null
    },
    model: {
      value: (_vm.selectedSubClass),
      callback: function($$v) {
        _vm.selectedSubClass = $$v
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "ddHeaders"
  }, [_vm._v("BRANDS:")]), _vm._v(" "), _c('searchable-dropdown', {
    attrs: {
      "id": 5,
      "list": _vm.brands,
      "selectedItem": (_vm.gettersAggInputDataName.brand) ? _vm.gettersAggInputDataName.brand.name : ""
    },
    model: {
      value: (_vm.selectedBrand),
      callback: function($$v) {
        _vm.selectedBrand = $$v
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ddHeaders"
  }, [_vm._v("STORES:")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "id": 300,
      "list": _vm.storeLevels,
      "defaultText": _vm.defaultStoreLevel,
      "selectedItem": (_vm.gettersAggInputDataName.storeLevel) ? _vm.gettersAggInputDataName.storeLevel.name : ""
    },
    model: {
      value: (_vm.selectedStoreLevel),
      callback: function($$v) {
        _vm.selectedStoreLevel = $$v
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.submitButtonPresent) ? _c('div', {
    staticClass: "submitButtonDiv"
  }, [_c('button', {
    class: {
      'submitButton': true, 'width_full': true, 'primary-green-bg': _vm.isSubmitButtonEnabled(), 'grey-text': !_vm.isSubmitButtonEnabled()
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isSubmitButtonEnabled()
    },
    on: {
      "click": function($event) {
        _vm.getPendingApprovals()
      }
    }
  }, [_vm._v("\n          Submit\n        ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49aafa6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SideBar.vue
// module id = 364
// module chunks = 2